import { FaHome, FaBuilding, FaUsers, FaUserCircle, FaChartBar } from 'react-icons/fa'
import { MdAssignment, MdVerifiedUser } from 'react-icons/md'

import permissions from 'commons/constants/permissions'

import featureFlags from './featureFlags'

const sidebarMenu = [
  {
    title: 'Home',
    icon: FaHome,
    url: '/',
    roles: [permissions.HOME_ACCESS],
    featureFlags: []
  },
  {
    title: 'SLA',
    icon: FaChartBar,
    url: '/sla',
    roles: [permissions.SLA_ACCESS],
    featureFlags: [featureFlags.SLA_ANALYSIS]
  },
  {
    title: 'Triagem',
    icon: MdVerifiedUser,
    url: '/screening',
    roles: [permissions.SCREENING_ACCESS],
    featureFlags: []
  },
  {
    title: 'Denúncias',
    icon: MdAssignment,
    url: '/complaint',
    roles: [permissions.COMPLAINTS_ACCESS, permissions.COMPLAINTS_LIST],
    featureFlags: []
  },
  {
    title: 'Usuários',
    icon: FaUsers,
    url: '/users',
    roles: [permissions.USERS_ACCESS],
    featureFlags: []
  },
  {
    title: 'Organizações',
    icon: FaBuilding,
    url: '/organizations',
    roles: [permissions.ORGANIZATIONS_ACCESS],
    featureFlags: []
  },
  {
    title: 'Minha conta',
    icon: FaUserCircle,
    url: '/my-account',
    roles: [],
    featureFlags: []
  }
]

export default sidebarMenu
